import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '@/hooks/use-mobile';

interface Badge {
  emoji: string;
  textKey: string;
}

export const RotatingBadges = () => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const isMobile = useIsMobile();

  const badges: Badge[] = [
    { emoji: '☀️', textKey: 'hero.morningRoutine.delivery' },
    { emoji: '☕', textKey: 'hero.morningRoutine.coffee' },
    { emoji: '✨', textKey: 'hero.morningRoutine.inspired' },
    { emoji: '🎯', textKey: 'hero.morningRoutine.personalize' },
  ];

  const totalItems = badges.length;

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % totalItems);
    }, 4800);

    return () => clearInterval(interval);
  }, [totalItems]);

  return (
    <div className="mb-6 min-h-[32px] lg:min-h-[40px] flex items-center justify-center">
      <div className="relative w-full">
        {/* Mobile: Single badge */}
        {isMobile && badges.map((badge, index) => (
          <div
            key={index}
            className={`flex items-center justify-center gap-2 text-sm text-muted-foreground transition-all duration-1000 ${
              index === activeIndex
                ? 'opacity-100 blur-0 scale-100 relative'
                : 'opacity-0 blur-sm scale-95 absolute inset-0'
            }`}
            style={{
              transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)'
            }}
          >
            <span className="text-lg">{badge.emoji}</span>
            <span className="font-medium">{t(badge.textKey)}</span>
          </div>
        ))}

        {/* Desktop: Single badge (same as mobile) */}
        {!isMobile && badges.map((badge, index) => (
          <div
            key={index}
            className={`flex items-center justify-center gap-2 text-sm text-muted-foreground transition-all duration-1000 ${
              index === activeIndex
                ? 'opacity-100 blur-0 scale-100 relative'
                : 'opacity-0 blur-sm scale-95 absolute inset-0'
            }`}
            style={{
              transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)'
            }}
          >
            <span className="text-lg">{badge.emoji}</span>
            <span className="font-medium">{t(badge.textKey)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
